import React from "react";
import PropTypes from "prop-types";

export const TickIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9 11.5l3 3 7-7"
      stroke={props.color ? props.color : "#44C272"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
TickIcon.propTypes = {
  color: PropTypes.string,
};
